import './product-accordion';
